import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { transformDraftToVariantVersion } from "./transformers";
import { TiVoAppVariantVersion, TiVoAppVariantDraft } from "./types";

export const useUpdateVariantVersionDraft = (
  id?: string,
  variantId?: string
) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<TiVoAppVariantVersion>,
    Error,
    Partial<TiVoAppVariantVersion>
  >({
    mutationFn: async (data) => {
      const results: ApiResponse<TiVoAppVariantDraft> = await dispatch(
        apiThatThrows.updateTiVoVariantVersionDraft.action({
          params: { id, variantId },
          options: {
            body: JSON.stringify({
              data: {
                attributes: data,
              },
            }),
          },
        })
      );

      await queryClient.setQueryData(
        ["variantVersionDraft", id, variantId],
        () => results
      );

      return {
        meta: results.meta,
        results: transformDraftToVariantVersion(results.results),
      };
    },
  });
};
